var fitt = require('fitt'),
fittKeys = fitt.keys,
fittCstr = fitt.cstr,
TYPE_STR = fitt.TYPE_STR,
TYPE_OBJ = fitt.TYPE_OBJ,
TYPE_NUM = fitt.TYPE_NUM,
TYPE_BOOL = fitt.TYPE_BOOL,

// http://www.ecma-international.org/ecma-262/5.1/#sec-4.3.16
// String is represented by 16-bit unsigned integer
SIZE_STRING = 2,
SIZE_BOOLEAN = 4,
// http://www.ecma-international.org/ecma-262/5.1/#sec-4.3.19
// Number is represented by 64-bit IEEE floating point number
SIZE_NUMBER = 8,
MAX_DEPTH = 64;

/**
                 * Calculates the size of Input in memory,
                 *
                 * @param  {Object|String|Number|Boolean} input     Type for which size is to be calculated
                 * @param  {Object} options                         Specify Options  (maxDepth, errMode)
                 * @param  {Number} depth                           Current recursion depth
                 * @return {Number}                                 Size in bytes
                 */
function memSize(input, options, depth) {
    var inputType = typeof input,
    maxDepth = options && options.maxDepth || MAX_DEPTH,
    errMode = options && options.errMode,
    sizeInBytes = 0,
    idx = 0,
    cnt,
    keys,
    key,
    val;

    depth = depth || 0;

    if (depth === maxDepth) {
        return memSize_errorHandler(errMode, sizeInBytes);
    }

    depth++;

    switch (inputType) {
        case TYPE_OBJ:

            if (input !== null) {
                if (Buffer.isBuffer(input)) {
                    return input.length;
                } else if (input instanceof Date || input instanceof RegExp) {
                    return memSize(fittCstr(input), options, depth);
                } else {
                    keys = fittKeys(input);
                    cnt = keys && keys.length;

                    for (; idx < cnt; idx++) {

                        key = keys[idx];
                        val = input[key];

                        sizeInBytes += memSize(key, options, depth);

                        try {
                            sizeInBytes += memSize(val, options, depth);
                        } catch (e) {
                            return memSize_errorHandler(errMode, sizeInBytes);
                        }
                    }

                    return sizeInBytes;
                }
            } else {
                return 0;
            }

        case TYPE_STR:
            return input.length * SIZE_STRING;

        case TYPE_BOOL:
            return SIZE_BOOLEAN;

        case TYPE_NUM:
            return isNaN(input) ? 0 : SIZE_NUMBER;

        default:
            return 0;}

}

function memSize_errorHandler(errMode, sizeInBytes) {
    return errMode == 0 ? 0 : sizeInBytes;
}

module.exports = memSize;


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-mem-size/index.js
// module id = 831
// module chunks = 0